export const RES_SUCCESS = 200;
export const RES_SUCCESS_201 = 201;
export const RES_BAD_REQUEST = 400;
export const RES_OVER_BLOCK = 432; // 팬딩 트랜잭션 상태,
